// extracted by mini-css-extract-plugin
export default {"paged":"_2qk-S","start-infscroll-button":"kJIo2","startInfscrollButton":"kJIo2","hidden":"C5sOU"};